<div class="folder-block" [class.expanded]="!isFolderCollapsed()">
  <div
    class="list-item gap-2"
    clickOrDoubleClick
    [class.collapsed]="collapsed()"
    (click)="!hasContextMenu() && onFolderSingleClick($event)"
    (singleClick)="hasContextMenu() && onFolderSingleClick($event)"
    (doubleClick)="onFolderDoubleClick($event)">
    <custom-icon name="folder" class="icon-primary" [size]="20" viewBox="0 0 20 20" />
    @if (!collapsed()) {
      <div class="list-item-title">
        <span class="text-truncate">
          {{ item().name }}
        </span>

        @if (item().isPublic && allowPublicBadge()) {
          <span class="badge badge-info">Public</span>
        }
      </div>

      @if (isPickerMode()) {
        <input
          type="checkbox"
          [checked]="isChecked()"
          [indeterminate]="isIndeterminate()"
          (change)="onToggleSelection($event)"
          (click)="$event.stopPropagation()" />
      }

      @if (hasContextMenu()) {
        <component-folder-context-menu
          [entity]="item()"
          [isInPublicFolder]="isInPublicFolder()"
          [isCreateDisabled]="isCreateDisabled()"
          (entityUpdated)="entityUpdated.emit($event)"
          (folderDelete)="folderDelete.emit($event)"
          (entityMoved)="entityMoved.emit($event)"
          (treeUpdated)="treeUpdated.emit($event)"
          (documentCreate)="documentCreate.emit($event)" />
      }

      <custom-icon name="chevronDown" class="chevron-icon me-2" [size]="12" viewBox="0 0 12 8" />
    }
  </div>

  @if (!isFolderCollapsed() && !collapsed()) {
    <div class="folder-content" animate.enter="entering-animation" animate.leave="leaving-animation">
      <component-document-tree
        [items]="item().content!"
        [folderId]="item().id"
        [folderIds]="folderIds()"
        [isPublicView]="isPublicView()"
        [disableDrag]="disableDrag()"
        [disableMove]="disableMove()"
        [expandAll]="expandAll()"
        [collapsed]="collapsed()"
        [isInPublicFolder]="item().isPublic"
        [isCreateDisabled]="isCreateDisabled()"
        [hasContextMenu]="hasContextMenu()"
        [allowPublicBadge]="allowPublicBadge()"
        [mode]="mode()"
        [(selectedDocumentsMap)]="selectedDocumentsMap"
        (entityUpdated)="entityUpdated.emit($event)"
        (documentDeleted)="documentDeleted.emit($event)"
        (duplicateDocument)="duplicateDocument.emit($event)"
        (folderDelete)="folderDelete.emit($event)"
        (entityMoved)="entityMoved.emit($event)"
        (treeUpdated)="treeUpdated.emit($event)"
        (documentCreate)="documentCreate.emit($event)"
        (drop)="drop.emit($event)" />

      @if (!item().content.length) {
        <span class="empty-message text-muted">Empty folder</span>
      }
    </div>
  }
</div>
